export const LOGO_LINK = 'https://nakedheart.ru/';
export const ABOUT_TEST_LINK = '';
export const NAKED_HEART_ONLINE_LINK = 'https://nakedheart.online/';
export const FUND_WEBSITE_LINK = LOGO_LINK;
export const PRIVACY_POLICY_LINK = 'https://nakedheart.ru/terms';
export const SPONSOR_LOGO_LINK = 'https://agulife.ru/pravonaschastie';
